<template>
	<div class="uimaker-image" :class="size?('uimaker-image-'+size):undefined">
		<ui-validate :value="errorText" :novalidate="novalidate" :nomessage="nomessage" :verifying="verifying" v-if="!view">
			<el-upload class="avatar-uploader" accept="image/*" :show-file-list="multiple?true:false" :action="action" :on-success="onSuccess" :on-preview="onPreview"
				:before-upload="beforeUpload" :before-remove="beforeRemove" :headers="headers" :on-remove="onRemove" :file-list="fileList" :list-type="multiple?'picture-card':''">
				<template v-if="multiple">
					<i class="el-icon-plus"></i>
				</template>
				<template v-else>
					<img v-if="value!=null&&value!=''" :src="imageUrl" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</template>
			</el-upload>
		</ui-validate>
		<div v-else-if="multiple" v-for="val in value.split(',')" class="avatars">
			<img v-if="val!=''" :src="getFullUrl(val)" class="avatar small" @click="imagePreview(val)"/>
		</div>
		<template v-else>
			<img v-if="value!=null&&value!=''" :src="imageUrl" class="avatar" @click="imagePreview(value)"/>
			<div v-else class="avatar-noimage">暂无图片</div>
		</template>
		<el-dialog :visible.sync="dialogVisible" title="预览" append-to-body>
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>

<script>
import uiValidate from './ui-validate.vue';
import store from '@/store'

export default {
	name:'ui-image',
	props:{
		value:{type:String,default:''},
		required:{type:Boolean,default:false},
		view:{type:Boolean,default:false},
		novalidate:{type:Boolean,default:false},
		nomessage:{type:Boolean,default:false},
		multiple:{type:Boolean,default:false},
		size:{type:String},
		filesize:{type:String,default:'20M'},
		uploadPath:{type:String,default:'/resource/upload'},
		imagePath:{type:String,default:''},
		responseValueField:{type:String,default:'data.url'},
		responseError:{type:Function,default:(response)=>{
			return response.code!==0;
		}},
		headers:{type:Object,default:()=>{return {Authorization:store.state.app.token}}},
	},
	data(){
		return {
			errorText:'',
			resourcePath:WEBCONFIG.alioss,
			action:WEBCONFIG.resourcePath+this.uploadPath,
			verifying:false,
			fileList:[],
			selfFileList:[],
			dialogVisible:false,
			dialogImageUrl:'',
		};
	},
	computed:{
		imageUrl(){
			return this.getFullUrl(this.value);
		}
	},
	created(){
		if(this.value!='')
			this.setFileList(this.value);
	},
	methods:{
		getFullUrl(value){
			if(value.slice(0,4).toLowerCase()=='http'){
				return value;
			}
			return this.resourcePath+this.imagePath+(value.length>0&&value[0]=='/'?'':'/')+value;
		},
		validate(){
			this.verifying=true;
			var isValid=false;
			if(this.required&&!this.view&&this.value===''){
				this.errorText='必填项不能为空';
			}
			else{
				this.errorText='';
				isValid=true;
			}
			return isValid;
		},
		getMessage(){
			return this.errorText;
		},
		getResponseValue(response){
			console.log('getResponseValue',response)
			var names=this.responseValueField.split('.');
			var obj=response;
			for(var i=0;i<names.length;i++){
				obj=obj[names[i]];
				if(obj==null)
					break;
			}
			console.log('obj',obj)
			return obj;
		},
		setResponseValue(val){
			console.log(val)
			var names=this.responseValueField.split('.');
			var result={};
			var obj=result;
			for(var i=0;i<names.length;i++){
				if(i==names.length-1){
					obj[names[i]]=val;
					break;
				}
				obj[names[i]]={};
				obj=obj[names[i]];
			}
			return result;
		},
		beforeUpload(file){
			if(file.type.split('/')[0]!='image'){
				this.$msgbox('上传图片格式不正确').catch(e=>{});
				return false;
			}
			if(this.filesize){
				let times=1;
				if(this.filesize.indexOf('M')!=-1){
					times=1024*1024;
				}
				else if(this.filesize.indexOf('K')!=-1){
					times=1024;
				}
				let filesize=parseInt(this.filesize)*times;
				if(filesize<file.size){
					this.$msgbox('上传图片大小不能超过'+this.filesize+'B').catch(e=>{});
					return false;
				}
			}
			return true;
		},
		onSuccess(response, file, fileList) {
			if(response.code !== 0 ||this.responseError(response)){
				this.$msgbox('上传失败').catch(e=>{});
				return;
			}
			let value='';
			if(this.multiple){
				this.selfFileList=fileList.url;
				value=fileList.map(p=>this.getResponseValue(p.response)).join(',');
			}
			else{
				value=this.getResponseValue(response);
			}
			this.$emit('input',value);
			this.$emit('change',value,response.data);
		},
		onRemove(file, fileList){
			if(file && file.status=="success"){
				let value='';
				if(this.multiple){
					this.selfFileList=fileList.url;
					value=fileList.map(p=>this.getResponseValue(p.response)).join(',');
				}
				else{
					value='';
				}
				this.$emit('input',value);
				this.$emit('change',value,'');
			}
		},
		beforeRemove(file, fileList) {
			if(file && file.status=="success"){
				return this.$confirm(`确定移除 ${ file.name }？`);
			}
		},
		onPreview(file) {
			this.dialogImageUrl=file.url;
			this.dialogVisible=true;
		},
		imagePreview(val) {
			this.dialogImageUrl=this.getFullUrl(val);
			this.dialogVisible=true;
		},
		setFileList(val){
			console.log('val',val)
			if(val!=null&&val!=''){
				var vals=val.split(',');
				console.log('vals',vals)
				for(var i=0;i<vals.length;i++){
					// console.log('x',this.selfFileList.filter(p=>this.getResponseValue(p.response.data.url)==vals[i]))
					if(this.selfFileList.filter(p=>this.getResponseValue(p.response.data)==vals[i]).length==0){
						this.selfFileList.push({name:'image',response:this.setResponseValue(vals[i]),url:this.getFullUrl(vals[i])});
					}
				}
				this.fileList=this.selfFileList;
				console.log('fff',this.fileList)
			}
			else{
				this.fileList=[];
			}
		}
	},
	watch:{
		value(val){
			this.setFileList(val);
			if(this.verifying)
				this.validate();
		},
	},
	components: {
        uiValidate
    }
}
</script>

<style lang="scss">
.uimaker-image{
	.avatar-uploader .el-upload {border:1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;position: relative;overflow: hidden;}
	.avatar-uploader .el-upload:hover {border-color: #409EFF;}
	.avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 178px;height: 178px;line-height: 178px;text-align: center;}
	.avatar {width: 178px;height: 178px;display: block;border-radius: 6px;cursor:pointer;}
	.avatar.small {width: 146px;height: 146px;}
	.avatars{display:inline-block;}
	.avatars .avatar{margin-right:10px;}
	.avatar-noimage {width: 178px;height: 178px;display: flex;align-items:center;justify-content:center;color:#DDDFE5;border:1px solid #DDDFE5;
		font-size:18px;font-weight:bold;letter-spacing:1px;border-radius: 6px;}
	&.uimaker-image-mini{
		.avatar{width:60px;height:60px;}
		.avatar.small{width:60px;height:60px;}
		.avatar-noimage{width:60px;height:60px;font-size:12px;letter-spacing:0;}
	}
}
</style>
